import API from "./axios";

export class CustomerService {
    enterpriseCustomerAccounts(status:any): Promise<any> {
        return API.post(`api/userapi.php`, { action: 'getEnterpriseCustomerAccounts', src: 'dashboard', retrievalmode: 'mysql',status:status });
    }

    retailCustomerAccounts(): Promise<any> {
        return API.post(`api/userapi.php`, { action: 'getRetailCustomerAccounts', src: 'dashboard', retrievalmode: 'mysql' });
    }

    // Create a new retail user manually (admin). Backend: userapi.php action 'addUserManually'.
    addRetailUser(username: any, mobileno: any, mailid: any, pin: any): Promise<any> {
        return API.post(`api/userapi.php`, { action: 'addUserManually', src: 'dashboard', retrievalmode: 'mysql',
            username: username, mobileno: mobileno, mailid: mailid, pin: pin });
    }

    // Create a new enterprise manually (admin). The admin user's mobile (mobileno) must already exist
    // as an ACTIVE retail user. Backend: userapi.php action 'addEntManually'.
    addEnterprise(entname: any, entaddress: any, entbranch: any, entgst: any, mobileno: any, ein: any, entalias: any): Promise<any> {
        return API.post(`api/userapi.php`, { action: 'addEntManually', src: 'dashboard', retrievalmode: 'mysql',
            entname: entname, entaddress: entaddress, entbranch: entbranch, entgst: entgst,
            mobileno: mobileno, ein: ein, entalias: entalias });
    }

    // Attach an existing app user to an enterprise (Enterprise -> Users -> Add User).
    // entId is REQUIRED and used to be missing here, so the backend wrote iEnterpriseId=0 -
    // this wrapper had no caller, which is why nobody noticed. entfeatures:1 links the user as
    // already approved (on the dashboard the admin IS the approver; the mobile app omits it and
    // still gets -1 = pending). force:1 re-submits past the "already belongs to X" warning (102).
    linkUserToEnterprise( mobileNo: any, entId: any, userRole: any = 'A', force: number = 0): Promise<any> {

        return API.post(`api/userapi.php`, { 'action': 'linkUserToEnterprise', mobileno: mobileNo,
            entid: entId, userrole: userRole, entfeatures: 1, force: force,
            src: 'dashboard', retrievalmode: 'mysql'});
    }

    enterpriseUserList( entId: any): Promise<any> {
      
        return API.post(`api/userapi.php`, { 'action': 'getEnterpriseUserList', 'entid': entId, 'src': 'dashboard', retrievalmode: 'mysql' });
    }
    
    removeUserFromEnterprise( userId: any): Promise<any> {
      
        return API.post(`api/userapi.php`, { 'action': 'removeUserFromEnterprise', 'userid': userId, 'src': 'dashboard', retrievalmode: 'mysql' });
    }


    updateEntAccountDetails( entId: any ,userid:any , ein:any , entname:any,entaddress:any,entbranch:any,entgst:any,status:any,entFeatures:any,enterpriseAlias:any,entMobile:any): Promise<any> {

        return API.post(`api/userapi.php`, { 'action': 'setEnterpriseCustomerDetails', 'entid': entId, 'userid':userid, 'ein': ein , 'entname':entname,'entaddress':entaddress,'entbranch':entbranch
        ,'entgst':entgst,'status': status, 'src': 'dashboard', retrievalmode: 'mysql','entfeatures':entFeatures , "entalias":enterpriseAlias , "entmobile":entMobile });
    }


    
    // force:1 confirms detaching an enterprise's LAST user (backend replies 102 without it).
    removeUserFromEnt(  userid:any, force:number = 0): Promise<any> {

        return API.post(`api/userapi.php`, { 'action': 'removeUserFromEnterprise', 'userid': userid, 'force': force, 'src': 'dashboard', retrievalmode: 'mysql' ,
                                                 });
    }


    updateRetailUser(  userid:any , username:any,mobileno:any,mailid:any,userrole:any,status:any): Promise<any> {
      
        return API.post(`api/userapi.php`, { 'action': 'updateRetailUser', 'userid': userid, 'username':username,'mobileno':mobileno,'mailid':mailid,
        'userrole':userrole,"status":status,'src': 'dashboard', retrievalmode: 'mysql' });
    }


        
    setSalesRep(  userid:any, salesrep:string ): Promise<any> {
      
        return API.post(`api/userapi.php`, { 'action': 'setSalesRep', 'userid': userid, 'src': 'dashboard', retrievalmode: 'mysql' ,
                                              'salesrep':salesrep   });
    }


    getSalesRepUsers(): Promise<any> {
        return API.post(`api/userapi.php`, { action: 'getSalesRepDetails', src: 'dashboard', retrievalmode: 'mysql' });
    }

    // All enterprises with their assigned salespersons (multiple reps per enterprise).
    // Used by the Enterprise Customers CSV export. Backend: userapi.php action 'getEnterpriseSalesRepReport'.
    getEnterpriseSalesRepReport(): Promise<any> {
        return API.post(`api/userapi.php`, { action: 'getEnterpriseSalesRepReport', src: 'dashboard', retrievalmode: 'mysql' });
    }

    // Bulk assign/unassign salespersons to enterprises from the CSV upload dialog.
    // rows: [{ein, mobile, op}] where op = 'A' (assign) | 'U' (unassign). Max 5000 rows.
    // Backend: userapi.php action 'bulkAssignEntSalesRep'.
    bulkAssignEntSalesRep(rows: any[]): Promise<any> {
        return API.post(`api/userapi.php`, { action: 'bulkAssignEntSalesRep', src: 'dashboard', retrievalmode: 'mysql', rows: rows });
    }


    getSalesRepEntDetails( userid:any,): Promise<any> {
        return API.post(`api/userapi.php`, { action: 'getSalesRepEntDetails', src: 'dashboard', retrievalmode: 'mysql' , 'userid': userid,  });
    }

    assignEntToSlaesRep(salesrepid:any,entid:any ,checkassignedEnt:string,status:number) {
        return API.post(`api/userapi.php`, { action: 'assignEntToSalesRep', src: 'dashboard', retrievalmode: 'mysql' , 'salesrepid': salesrepid, 'entid':entid , 'checkassignedEnt':checkassignedEnt , 'status':status});
    }

   /* assignEntToSlaesRepConfirm(salesrepid:any,entid:any,checkassignedEnt:string){
        return API.post(`api/userapi.php`, { action: 'assignEntToSlaesRep', src: 'dashboard', retrievalmode: 'mysql' , 'salesrepid': salesrepid, 'entid':entid , });
    } */

    getCustomerFeedback(status:number): Promise<any> {
        return API.post(`api/userapi.php`, {"action":"getCustomerFeedback","src":"dashboard","retrievalmode":"mysql"});
    }

 
    getSalesRepFeedbackList(salesrepid:any,entId:any,fromdate:any,todate:any): Promise<any> {
        return API.post(`api/index.php`, {"action":"getSalesFeedback","src":"dashboard","retrievalmode":"mysql",  "salesrepid": salesrepid,
        "entId": entId , "fromdate":fromdate , "todate":todate});
    }

  


    /*
unassigned to assigned 
{
"entids": "2,4,45,",
"salespersonid": 37

}


assigned to unassigned

{
"entids": "2,4,45,",
"salespersonid" : -1

}

    */

    
    

}